import React from "react";
import { LegacyRef, forwardRef, useState } from "react";

const LiveDraftTooltip = forwardRef(({
    id,
    relativeRef,
    color,
    label,
    handleClose,
    tooltipType = 'id'
} : {
    handleClose: (e: React.MouseEvent<any>) => void,
    id: string,
    relativeRef: HTMLDivElement,
    color?: string,
    label?: string,
    tooltipType?: 'id' | 'product'
}, ref: LegacyRef<HTMLDivElement>) => {
    const [active, setActive] = useState(false)

    function handle_clipbord(text: string) {
        setActive(true)
        navigator.clipboard.writeText(text);
        setTimeout(() => setActive(false), 1000)
    }

    return (
        <div
            ref={ref}
            className={`tw-absolute tw-z-[1003] tw-bg-white tw-rounded tw-shadow tw-translate-y-[min(50%,28px)]`}
            style={{
                top: (relativeRef?.getBoundingClientRect().y ?? 0),
                left: (relativeRef?.getBoundingClientRect().x ?? 0),
            }}
            onMouseLeave={handleClose}
        >
            <span className={`tw-flex tw-flex-col tw-top-full tw-left-0 tw-bg-black tw-rounded tw-text-white tw-p-2 tw-px-2 tw-leading-7 tw-z-[1020]`}>
                {(color || label) && 
                    <div className={`tw-text-white tw-flex tw-items-center tw-space-x-1.5`}>
                        {color && <span className={`tw-w-2.5 tw-h-2.5 tw-block tw-rounded-sm`} style={{background: color}}/>}
                        {/* {label && <span>{label}</span>} */}
                    </div>
                }
                <div className={`tw-space-x-2.5 tw-flex tw-min-w-max`}>
                    <span className="tw-border-r tw-border-gray-600 tw-pr-2.5">
                        {label === 'UID' ? 'UID: ' : ''}
                        <b>{id}</b>
                    </span>
                    <button 
                        className={`tw-px-2.5 tw-mx-0.5 tw-rounded ${active && 'tw-bg-success'}`} 
                        disabled={active}
                        onClick={() => handle_clipbord(id)}>
                        <i className={`far fa-copy`}/> {active ? <span>Copied</span> : <span>Copy</span>}
                    </button>
                </div>
            </span>
        </div>
    )
})
    

export default LiveDraftTooltip;